module.exports = __webpack_public_path__ + "static/img/tx006.af408bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/tx006.png
// module id = 1vWg
// module chunks = 1